import React, { ReactNode } from 'react';
import moment from 'moment';
import { useAppSelector } from 'flow/hooks/useRedux';
import Tooltip from 'flow/components/ui-components/Tooltip';
import { selectEventTimestamp } from 'flow/selectors/TicketEventSelectors';
import { TicketKey } from 'flow/types/EntityKeys';
import { TicketActionEventKey } from 'flow/types/TicketEventData';

interface Props {
    ticketKey: TicketKey;
    eventKey: TicketActionEventKey;
    tooltipLabel?: string;
    children: ReactNode;
}

// System action events (assignee/state/subject changed) render as a small
// centred, low-prominence line: text + timestamp, no icon or backplate.
const ActionEventRow = ({
    ticketKey,
    eventKey,
    tooltipLabel,
    children,
}: Props) => {
    const timestamp = useAppSelector((state) =>
        selectEventTimestamp(state, ticketKey, eventKey),
    );

    const row = (
        <div className="flex items-center gap-1 text-xs leading-5 text-gray-500 [&_strong]:font-normal">
            <span className="wrap-break-word">{children}</span>
            <span className="shrink-0">
                {timestamp ? moment(timestamp).format('LT') : null}
            </span>
        </div>
    );

    return (
        <div className="flex w-full cursor-default justify-center py-1.5">
            {tooltipLabel ? <Tooltip label={tooltipLabel}>{row}</Tooltip> : row}
        </div>
    );
};

export default ActionEventRow;
